import React from "react";
import "./Header.css"
import {Link} from "react-router-dom";
import {HeaderUserData} from "./HeaderUserData";
import logo from "../../../ketnutri.svg"
import {useSelector} from "react-redux";
import {Store} from "../../../store/reducer";
import ReactTooltip from "react-tooltip";
import {useTranslation} from "react-i18next";

function Header() {
  const {loggedIn} = useSelector((state: Store) => state.AuthState);
  const {t} = useTranslation();

  return (
    <nav className="navbar navbar-expand-lg navbar-ketnutri navbar-light text-dark bg-ketnutri shadow-sm">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Ket.Nutri" className="brand-icon logo"/>
          <span>&nbsp;Ket.Nutri</span>
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"/>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/">{t("header.home")}</Link>
            </li>
            <li className="nav-item">
              <Link data-tip data-for='login-required-calculoVET' className="nav-link" to="/calculoVET">{t("calculo_vet.page_title")}</Link>
              {loggedIn || (
                <ReactTooltip id='login-required-calculoVET' type='dark' effect='solid'>
                  <span>{t("header.login_required_tooltip")}</span>
                </ReactTooltip>
              )}
            </li>
            <li className="nav-item">
              <Link data-tip data-for='login-required-gerador-rotulos' className="nav-link" to="/geradorRotulos">{t("rotulo.page_title")}</Link>
              {loggedIn || (
                <ReactTooltip id='login-required-gerador-rotulos' type='dark' effect='solid'>
                  <span>{t("header.login_required_tooltip")}</span>
                </ReactTooltip>
              )}
            </li>
          </ul>
          <HeaderUserData/>
        </div>
      </div>
    </nav>
  );
}

export default Header;
